import React from "react"

import { ProductConfiguratorModeSelectOverlayView } from "./ui/ProductConfiguratorModeSelectOverlayView"

export interface ProductConfiguratorModeSelectOverlayModel {
  title: string
  image: React.ReactNode
  isConfigurationAvailable: boolean
  isExternalDimensioningAvailable: boolean
  onConfigurationSelect: () => void
  onDimensioningSelect: () => void
  closeOverlay: () => void
}

export interface ProductConfiguratorModeSelectOverlayProps
  extends ProductConfiguratorModeSelectOverlayModel {}

function ProductConfiguratorModeSelectOverlayComponent(
  props: ProductConfiguratorModeSelectOverlayProps
) {
  return <ProductConfiguratorModeSelectOverlayView {...props} />
}

export const ProductConfiguratorModeSelectOverlay = React.memo(
  ProductConfiguratorModeSelectOverlayComponent
) as typeof ProductConfiguratorModeSelectOverlayComponent
